
/**
 * 顧客主キー
 */
export class CustomerPrimaryKey {
    /** 都道府県コード */
    prefectureCode = ""
    /** 顧客コード (999999) */
    code = ""
    /** 枝番 (99) */
    branchNumber = ""

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<CustomerPrimaryKey>) {
        Object.assign(this, init)
    }
}

/**
 * 顧客
 */
export class Customer {
    /** 主キー */
    pk = new CustomerPrimaryKey()
    /** 顧客名 */
    name = ""
    /** 顧客略称名 */
    shortName = ""
    /** 紹介者コード 顧客コード (999999) or 他システムのコード */
    introducerCode = ""
    /** 郵便番号 (999-9999) */
    zipCode = ""
    /** 住所１ */
    address1 = ""
    /** 住所２ */
    address2 = ""
    /** 部署名 */
    department = ""
    /** 役職 */
    position = ""
    /** 担当者名 */
    contact = ""
    /** 電話番号 */
    tel = ""
    /** FAX番号 */
    fax = ""
    /** メールアドレス */
    mail = ""
    /** 営業拠点 1:出雲 2:横浜 */
    salesOffice = 1
    /** 顧客区分 1:新規 2:既存 */
    customerClassification = 1
    /** 報告書添付ルール 1:個別のみ 2:合算のみ 3:両方 */
    billingRule = 1
    /* 合算請求締め日: 0:なし、 31:月末 */
    deadline = 0
    /** 代理店 0:顧客 1:代理店 */
    agencied = false
    /** 納期計算 0:土日考慮なし 1:土日考慮あり */
    deliveryCalculation = false

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<Customer>) {
        Object.assign(this, init)
    }
}
